import { getPageInfoInitActions, getCommonSectionInitActions } from './common';

import {
  setSelectedNoteId,
  setSelectedFolder,
} from '../../actions/backroomSection';
import { GroupNotesFolderType } from '../../../types/backroomSection';

export function getBackroomSectionInitActions(responseData, requestParams) {
  return [
    ...getPageInfoInitActions(responseData, requestParams),
    setSelectedNoteId(requestParams.noteid),
    setSelectedFolder(GroupNotesFolderType.INBOX),
    ...getCommonSectionInitActions(responseData, requestParams, 'backroom'),
  ].filter(action => action);
}
